import React, { Component } from "react";
import firebase from 'firebase';
import withAuthorization from '../Session/withAuthorization';
import { compose } from 'recompose';
import '../css/main.css';
import Spinner from "../Spinner";

class UploadUser extends Component{
  constructor(props){
    super(props);
    this.state = {
      error : false,
      progress : false
    }
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
    this.setState({
      error : ''
    })
    var user = {}, self = this , errors= [];
    user.name = this.name.value;
    user.email = this.email.value;
    user.aadhar_no = this.aadhar_no.value;
    user.pan_no = this.pan_no.value;
    user.contact = this.contact.value;
    user.panchayat_block = this.panchayat.value;
    user.working_area = this.working_area.value;

    Object.keys(user).map(temp => {
      if(user[temp] === ""){
        errors.push(temp)
      }
    })
    if(errors.length > 0){
      self.setState({
        error : errors
      })
    }
    else{
      this.setState({
        progress : true
      })
      var te = { email: user.email, emailVerified: true,password:this.password.value,displayName: user.Name,disabled: false }
      console.log(te , user);
      self.postData('https://us-central1-sri-universal-suraksha.cloudfunctions.net/createUser', te)
        .then(data => {
          console.log(data)
            if(data.uid){
              user['id'] = data.uid;  
              firebase.database().ref('/users/vendors').child(data.uid).child('details').set(user);
              self.uploadForm.reset();
              self.setState({
                error : false,
                progress : false
              })
              alert("User Created Successfully !!")
            }
            else{
              self.setState({
                progress : false
              })
              alert("Error while creating user !! "+ data.error.message)
            }
          }
        )
        .catch(error => {
          alert(error);
          console.log(error)
        }); 
    }
  }

  postData(url = ``, data) {
    return new Promise(function(resolve, reject){
      fetch(url, {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "same-origin", // include, *same-origin, omit
        headers: {
            "Content-Type": "text/plain; charset=utf-8",
            "Access-Control-Allow-Origin": "*",
            'Accept-Encoding' : 'gzip'
        },
        body: JSON.stringify(data), // body data type must match "Content-Type" header
      })
      .then(response => resolve(response.json()))
      .catch((err)=>
      {
        console.log(err.json())
        reject(err);
      }); // parses response to JSON
    })
  }

  render(){
    return(
      <div className=" display_home" style={{display: 'flex' , flexDirection: 'column'}}>
        <label className="fs-24 m-l-20" style={{fontWeight : '600' , display:'flex'}}>Create Vendors For Sri Universal Suraksha Card</label>
        <div className="limiter">
          <form id="form_user" ref={(el) => this.uploadForm = el}>
            <div className="form_content">
              <div>
                <label>Name* : </label><br/>
                <input 
                  className="wrap-input100" 
                  type="text" 
                  placeholder="Name" 
                  name="name" 
                  required
                  ref={node => (this.name = node)}
                  style={{border : '1px'}}>
                </input> 
              </div>
              <div>
                <label>Email* : </label>
                <input 
                  className="wrap-input100" 
                  type="text" 
                  placeholder="Name" 
                  name="email" 
                  required
                  ref={node => (this.email = node)}
                  style={{border : '1px'}}>
                </input> 
              </div>   
              <div>
                <label>Password* : </label>
                <input 
                  className="wrap-input100" 
                  type="text" 
                  placeholder="Name" 
                  name="password" 
                  required
                  ref={node => (this.password = node)}
                  style={{border : '1px'}}>
                </input> 
              </div>      
              <div>
                <label>Panchayat Block : </label>
                <input 
                  className = "wrap-input100"
                  type = "text"
                  placeholder = "Panchayat Block"
                  name = "panchayat"
                  ref={node => (this.panchayat = node)}
                  style = {{border: '1px'}}> 
                </input>
              </div>
              <div>
                <label>Mobile No* : </label>
                <input 
                  className="wrap-input100" 
                  type="number" 
                  placeholder="Contact no." 
                  name="mobile" 
                  required
                  pattern="\d*" 
                  maxlength="10"
                  oninput="this.value=this.value.slice(0,this.maxLength)"
                  maxLength = {10}
                  ref={node => (this.contact = node)}
                  style={{border : '1px'}}></input> 
              </div>
              <div>
                <label>PAN No* : </label>
                <input 
                  className="wrap-input100" 
                  type="string" 
                  placeholder="PAN no." 
                  name="pan" 
                  required
                  pattern="\d*" 
                  maxlength="10"
                  maxLength = {10}
                  ref={node => (this.pan_no = node)}
                  style={{border : '1px'}}></input> 
              </div>
              <div>
                <label>Adhar Card No* : </label>
                <input 
                  className="wrap-input100" 
                  type="number" 
                  required
                  maxLength ={10}
                  placeholder="Adhar No." 
                  name="adhar" 
                  ref={node => (this.aadhar_no = node)}
                  style={{border : '1px'}}></input> 
              </div>
              <div>
                <label>Working Area : </label>
                <input 
                  className="wrap-input100" 
                  type="text" 
                  placeholder="Nominee Name" 
                  name="nomiee_name" 
                  ref={node => (this.working_area = node)}
                  style={{border : '1px'}}></input> 
              </div>
            </div>
            {this.state.error.length > 0 ? <span className="error">Please input {(this.state.error).join(", ").toUpperCase()}</span> : null}
          <div className="modal_button_align" >
            <button className="container-login100" type="button" onClick={() => this.handleSubmit()}>Submit</button>
          </div>
          </form>
        </div>
        {this.state.progress ? <Spinner /> : null}
      </div>
    )
  }
}

const authCondition = (authUser) => !!authUser;

export default compose(withAuthorization(authCondition))(UploadUser);